/**
 * Constants for feature flagging system
 */

// Query parameter prefix for feature flags
export const FEATURE_FLAG_QUERY_PREFIX = "featureFlag_";

// Header prefix for feature flags
export const FEATURE_FLAG_HEADER_PREFIX = "x-feature-flag-";
